import { render, staticRenderFns } from "./StandaloneDownload.vue?vue&type=template&id=140ace3a&scoped=true"
import script from "./StandaloneDownload.vue?vue&type=script&lang=ts"
export * from "./StandaloneDownload.vue?vue&type=script&lang=ts"
import style0 from "./StandaloneDownload.vue?vue&type=style&index=0&id=140ace3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ace3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
